import React from 'react';
import { inject, observer} from 'mobx-react';
import {Button, Modal,message} from 'antd'
import * as mobx from 'mobx';
import isEmpty from 'lodash/isEmpty'
// import Immutable from 'immutable'
// const is = Immutable.is;
import Simple from './simple'
import Full from './full'
import '../../style/add.less';
import {jumpToHrmCard} from '../../util/pulic-func'
import {WeaTab,WeaTop,WeaSearchGroup,WeaRightMenu,WeaPopoverHrm,WeaLeftRightLayout,
        WeaOrgTree,WeaSelect,WeaErrorPage, WeaTools,WeaFormItem, WeaSearchBrowserBox} from 'ecCom'
import {WeaTableNew,WeaSwitch} from 'comsMobx';
const WeaTable = WeaTableNew.WeaTable;
import * as PublicFunc from '../../util/pulic-func';
import {i18n} from '../../public/i18n';
const toJS = mobx.toJS;

let _this;
@inject('hrmAdd')

@observer
class Add extends React.Component {
    constructor(props) {
        super(props);
        _this = this;
        const funcs = ['onOperatesClick','jumpToHrmCard', 'openFullmode','update'];
        funcs.forEach(f=> this[f] = this[f].bind(this))
    }
    componentDidMount() {
        const {hrmAdd} = this.props;
        hrmAdd.getData();
        hrmAdd.simpleVisible = true;
    }
    componentWillReceiveProps(nextProps) {
        const { hrmAdd } = this.props;
        const keyOld = this.props.location.key;
        const keyNew = nextProps.location.key;
        if(keyOld !== keyNew) {
            hrmAdd.setShowSearchAd(false);
            this.componentDidMount();
        }
    }
    componentWillUnmount() {
        const {hrmAdd} = this.props;
        hrmAdd.setShowSearchAd(false);
        hrmAdd.simpleVisible = false;
    }
    render() {
        const {hrmAdd} = this.props;
        const {dataKey,formSearch,title,searchParamsAd,showSearchAd,table,simpleVisible, fullVisible} = hrmAdd;
        const formParams = formSearch.getFormParams();
        return  <div className='wea-myhrm-Add'>
                <Simple
                    visible={simpleVisible}
                    openFullmode={this.openFullmode}
                    update={this.update}
                    onCancel={()=> {hrmAdd.simpleVisible = false;}}
                />
                <Full
                    visible={fullVisible}
                    update={this.update}
                    onCancel={()=> {hrmAdd.fullVisible = false;}}
                />
                <WeaRightMenu datas={this.getRightMenu()} onClick={this.onRightMenuClick.bind(this)}>
                    <WeaTop
                        title={title()}
                        icon={<i className='icon-coms-hrm' />}
                        iconBgcolor='#217346'
                        buttons={this.getButtons()}
                        buttonSpace={10}
                        showDropIcon={true}
                        dropMenuDatas={this.getRightMenu()}
                        onDropMenuClick={this.onRightMenuClick.bind(this)}
                    >
                        <div style={{height: '100%'}}>
                            <WeaLeftRightLayout isNew={true} leftCom={this.getTree()} >
                                <WeaTab
                                    onlyShowRight={true}
                                    buttonsAd={this.getTabButtonsAd()}
                                    searchType={['base','advanced']}
                                    searchsBaseValue={formParams.resourcename}
                                    setShowSearchAd={bool => {hrmAdd.setShowSearchAd(bool)}}
                                    hideSearchAd={() => hrmAdd.setShowSearchAd(false)}
                                    searchsAd={this.getSearchs(true)}
                                    showSearchAd={showSearchAd}
                                    onSearch={v => {hrmAdd.doSearch()}}
                                    onSearchChange={v => {
                                        formSearch.updateFields({
                                            resourcename:{name:'resourcename',value:v},
                                          });
                                        }}
                                    />
                                    <WeaTable comsWeaTableStore={table}
                                    hasOrder={true}
                                    needScroll={true}
                                    getColumns={c=>this.reRenderColumns(c)}
                                    onOperatesClick={this.onOperatesClick}
                                    />
                            </WeaLeftRightLayout>
                        </div>
                    </WeaTop>
                </WeaRightMenu>
            </div>
    }
    reRenderColumns(columns){
        columns.forEach(c=>{
            if(c.dataIndex=='lastname'){
                c.render = function(text, record){
                        return    <span style={{cursor:'pointer'}} className='wea-hrm-linkstyle' onClick={_this.jumpToHrmCard.bind(null,record.id)}>{record.lastname}</span>
                }
            } else {
                c.render = function(text, record){
                    let valueSpan = record[c.dataIndex + "span"] !== undefined ? record[c.dataIndex + "span"] : record[c.dataIndex];
                    return <span dangerouslySetInnerHTML={{__html: valueSpan}}></span>
                }
            }
        })
        return columns;
    }
    jumpToHrmCard(hrmId,...rest){
        jumpToHrmCard(hrmId)
    }

    update(){
        const { hrmAdd } = this.props;
        hrmAdd.update();
    }
    onOperatesClick=(record,index,operate,flag,argumentString)=>{
        const fn = operate.href ? operate.href.split(':')[1].split('(')[0] : '';
        const id = record.id ? record.id : '';
        PublicFunc[fn](id);
    }
    addhrm() {
        const { hrmAdd } = this.props;
        hrmAdd.simpleVisible = true;
    }
    openFullmode() {
        const { hrmAdd } = this.props;
        hrmAdd.openFullmode();
    }
    getButtons() {
        const { hrmAdd } = this.props;
        const {title} = hrmAdd;
        let btns =[];
        btns.push(
            <Button type="primary" onClick={()=>this.addhrm()} >{title()}</Button>
        );
        return btns
    }
    getTabButtonsAd() {
        const { hrmAdd } = this.props;
        const { formSearch } = hrmAdd;
        return [
            (<Button type="primary" onClick={()=>{hrmAdd.doSearch();hrmAdd.setShowSearchAd(false)}}>{i18n.button.search()}</Button>),
            (<Button type="ghost" onClick={()=>{formSearch.reset();}}>{i18n.button.reset()}</Button>),
            (<Button type="ghost" onClick={()=>{hrmAdd.setShowSearchAd(false)}}>{i18n.button.cancel()}</Button>)
        ]
    }

    getSearchs(bool) {
        const { hrmAdd } = this.props;
        const {condition, formSearch} = hrmAdd;
        const {isFormInit} = formSearch;
        let searchGroupArr = [];
        isFormInit && toJS(condition) && toJS(condition).forEach((item,index)=>{
            searchGroupArr.push(
                <WeaSearchGroup
                     needTigger={true}
                     title={this.getTitle(index)}
                     showGroup={this.isShowFields(index)}
                     items={this.getFields(bool,index)}
                 />
            )
        })
        return searchGroupArr;
    }
    getTitle(index=0) {
        const { hrmAdd } = this.props;
        const {condition} = hrmAdd;
        return !isEmpty(toJS(condition)) && toJS(condition)[index].title
    }
    isShowFields(index=0) {
        const { hrmAdd } = this.props;
        const {condition} = hrmAdd;
        return !isEmpty(toJS(condition)) &&toJS(condition)[index].defaultshow
    }
    getFields = (bool=false,index=0) => {
        const { hrmAdd } = this.props;
        const {formSearch,condition} = hrmAdd;
        const browserConditions = toJS(condition);
        const fieldsData = !isEmpty(browserConditions) && browserConditions[index].items;
        let items = new Array();
        fieldsData.forEach( field => {
            field && items.push({
                com:<WeaFormItem
                    label={`${field.label}`}
                    labelCol={{span: `${field.labelcol}`}}
                    wrapperCol={{span: `${field.fieldcol}`}}>
                        <WeaSwitch fieldConfig={field} form={formSearch}/>
                    </WeaFormItem>,
                colSpan:field.colSpan || 2
            });
        });
     return items;
    }
    getTree() {
        return <WeaOrgTree
                loading
                needDropMenu={false}
                needSearch
                isLoadSubDepartment={true}
                inputLeftDom = {`<b>${i18n.label.organization()}</b>`}
                topPrefix={'hrmAdd'}
                treeNodeClick={this.treeNodeClick}
                params = {{rightStr:'HrmResourceAdd:Add'}}
            />
    }
    treeNodeClick = (nodeObj) => {
        const type = nodeObj.node.props.type || '0';
        const id = nodeObj.node.props.id || '';
        const name = nodeObj.node.props.name || '';
        const { hrmAdd } = this.props;
        const { formSearch } = hrmAdd;
        hrmAdd.setShowSearchAd(false);
        let params = {};
        if(type=='1'){
            params.subcompanyid1 = id;
        }
        if(type=='2'){
            params.departmentid = id;
        }
        hrmAdd.doSearch(params);
    }
    getRightMenu(){
            const keys = this.getSelectedRowKeys();
            const arr = [
                {
                    icon: <i className='icon-coms-New-Flow'/>,
                    content: i18n.module.createResource()
                },{
                    icon: <i className='icon-coms-ws'/>,
                    content: i18n.button.search()
                }, {
                    icon: <i className='icon-coms-task-list'/>,
                    content: i18n.button.columnVisibleSetting()
                }
                // ,{
                //         icon: <i className='icon-Right-menu-Batch-sharing'/>,
                //         content:'收藏',
                // },{
                //         icon: <i className='icon-Right-menu-Custom'/>,
                //         content:'帮助'
                // }
            ];
            return arr;
    }
    onRightMenuClick(key){
        switch(key){
            case '0':
                    this.addhrm();
                    break;
            case '1':
                    this.doSearch();
                    break;
            case '2':
                    this.definedColumn();
                    break;
        }
    }
    getSelectedRowKeys(){
        const { hrmAdd } = this.props;
        const { table } = hrmAdd;
        const selectedRowKeys = table.selectedRowKeys;
        return selectedRowKeys;
      }
    sendEmessage(){
        const keys = this.getSelectedRowKeys();
        const ids = keys ? keys.join(',') : '';
        PublicFunc.sendEmessage(ids);
    }
    exportExcel(){
        const { hrmAdd } = this.props;
        const { dataKey} = hrmAdd;
        dataKey && hrmAdd.exportExcel(dataKey);
    }
    doSearch() {
        const { hrmAdd } = this.props;
        hrmAdd.doSearch();
    }

    definedColumn() {
        const { hrmAdd } = this.props;
        const { table} = hrmAdd;
        table.setColSetVisible(true);
        table.tableColSet(true);
    }
}

export default Add


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/add/add.js